<template>
  <div>
    <div v-if="!mentor" class="d-flex flex-row-reverse">
      <v-btn class="js-budget-add default-action-btn" @click="$emit('add')"
        >Add</v-btn
      >
      <v-overlay :value="showOverlay" class="d-flex" opacity="0.3">
        <v-card light class="pa-5">
          <v-card-title>Create a new Budget</v-card-title>
          <v-text-field v-model="name" class="js-budget-name" label="name" />
          <v-btn
            :disabled="name.length == 0"
            @click="$emit('save', name)"
            class="default-action-btn js-budget-save"
            >Save</v-btn
          >
          <v-btn @click="$emit('cancel')" class="cancel-action-btn"
            >Cancel</v-btn
          >
        </v-card>
      </v-overlay>
    </div>

    <v-data-table
      :items="budgets"
      :headers="headers"
      :disable-pagination="true"
      :hide-default-footer="true"
      @click:row="clickRow"
      class="pointer"
    >
      <template v-slot:[`item.name`]="{ item }">
        <div class="link">{{ item.name }}</div>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <div class="link">{{ formatDate(item.created_at) }}</div>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <div class="link">{{ formatDate(item.updated_at) }}</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"

export default {
  mixins: [titleMixin],
  props: {
    budgets: Array,
    mentor: { type: Boolean, default: false },
    showOverlay: Boolean
  },
  data: function() {
    return {
      title: "My Budgets",
      overlay: false,
      name: "",
      headers: [
        {
          text: "name",
          value: "name",
          sortable: true
        },
        {
          text: "Modified Date",
          value: "updated_at",
          width: "130px"
        },
        {
          text: "Created Date",
          value: "created_at",
          width: "130px"
        }
      ]
    }
  },
  methods: {
    clickRow(row) {
      let componentName = this.mentor ? "budgetViewMentor" : "budgetView"

      this.$router.push({
        name: componentName,
        params: { budgetId: row.id },
        query: { edit: !this.mentor }
      })
    },
    formatDate(date) {
      return date
        ? new Date(date).toLocaleString("en-US", {
            dateStyle: "short",
            timeStyle: "short"
          })
        : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
@import "../../../scss/buttons";

.link {
  color: $dark-yellow;
}

.pointer {
  cursor: pointer;
}
</style>
